import request from '@/utils/request'
import qs from 'qs'

const proxyUrl = process.env.Communityapi;
const Jingjiribao = process.env.Jingjiribao;
const Community = process.env.Community;

//获取分类
export const selectforums = (data) => {
  return request({
    method: 'post',
    url: Community + '/topic/selectforums',
  })
};

//图片上传
export const NewTopicImg = (data) => {
  return request({
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'post',
    url: proxyUrl + '/circle/saveNewTopicImgs/upload',
    data: data.data
  })
};

// 上传 视频
export const NewTopicVideo = (data) => {
  return request({
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'post',
    url: proxyUrl + '/circle/saveNewTopicVideo/upload',
    data: data.data
  })
};

//发布作品 保存
export const saveNewTopic = (data) => {
  return request({
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    method: 'post',
    url: proxyUrl + '/circle/saveNewTopic',
    data: data,
  })
};




// WEBPACK FOOTER //
// ./src/utils/api/addwork.js